import React, { Component } from 'react';
import './App.css';
import $ from 'jquery';


import {Link} from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import {withTranslation, Trans} from "react-i18next";

import {Helmet} from "react-helmet";
import personThumb from "./img/personThumb.png";

class Office extends Component {

    constructor (props){
        super(props);

        this.state = {
            div1showed: false,
            div2showed: false,
            div3showed: false
        };
    }


    hoverHandle(event) {

       // event.target.classList.add('active');
        if(event === 1){
            this.setState({
                div1showed : true
            });
        }
        if(event === 2){
            this.setState({
                div2showed : true
            });
        }
        if(event === 3){
            this.setState({
                div3showed : true
            });
        }

        if(event === 4){
            this.setState({
                div1showed : false,
                div2showed : false,
                div3showed : false

            });
        }

    }

    componentDidMount(){

    }



    render() {

      const { i18n, t } = this.props;

    return (
<div  >
    <Helmet>
        <title>{i18n.exists('office.seo.title') ? t('office.seo.title') : "Agile CE"}</title>
        <meta name="description" content={i18n.exists('office.seo.description') ? t('office.seo.description') : ""} />
        <meta property="og:title" content={i18n.exists('office.seo.title') ? t('office.seo.title') : "Agile CE"} />
        <meta property="og:description" content={i18n.exists('office.seo.description') ? t('office.seo.description') : ""} />
    </Helmet>
        <div className="container content fade-in-website" id="office"  >

            <div className={"row"}>


                <div className={"col-md-12"}>

                   <br/><br/><br/>
            <h3>
              Statický Agile tým<br/><br/>
            </h3>

            <div className={"row"}>
                <div className={"col-md-4"}>
                    <br/>

                    <h4>Ing. Pavel Nejedlý</h4>
                    <span>HIP, projektant</span><br/>
                    <span>E-mail: <a href={"mailto:pavel.nejedly@agile-ce.cz"}>pavel.nejedly@agile-ce.cz</a></span><br/>

                </div>
                <div className={"col-md-4"}>
                    <br/>
                    <h4>Jindřich Mikšík</h4>
                    <span>Projektant, specialista na armovací výkresy</span><br/>
                    <span>E-mail: <a href={"mailto:jindrich.miksik@agile-ce.cz"}>jindrich.miksik@agile-ce.cz</a></span><br/>

                </div>
                <div className={"col-md-4"}>
                    <br/>

                    <h4>Marek Těšínský</h4>
                    <span>Projektant</span><br/>
                    <span>E-mail: <a href={"mailto:marek.tesinsky@agile-ce.cz"}>marek.tesinsky@agile-ce.cz</a></span><br/>

                </div>
                <div className={"col-md-4"}>

                    <br/><br/>
                    <h4>Jiří Šenk</h4>
                    <span>Specialista na armovací výkresy</span><br/>
                    <span>E-mail: <a href={"mailto:jiri.senk@agile-ce.cz"}>jiri.senk@agile-ce.cz</a></span><br/>

                </div>


            </div>
                    <br/><br/>
                    <h3>
                        Statický Agilní BIM tým<br/><br/>
                    </h3>

                    <div className={"row"}>
                        <div className={"col-md-4"}>
                            <br/>

                            <h4>Stanislav Krejčí, MSc.</h4>
                            <span>BIM koordinátor</span><br/>
                            <span>E-mail: <a href={"mailto:stanislav.krejci@agile-ce.cz"}>stanislav.krejci@agile-ce.cz</a></span><br/>

                        </div>
                        <div className={"col-md-4"}>
                            <br/>
                            <h4>Milan Humler, DiS</h4>
                            <span>BIM projektant</span><br/>
                            <span>E-mail: <a href={"mailto:milan.humler@agile-ce.cz"}>milan.humler@agile-ce.cz</a></span><br/>

                        </div>
                        <div className={"col-md-4"}>
                            <br/>
                            <h4>Bc. Dmitriy Burdenkov</h4>
                            <span>BIM projektant</span><br/>
                            <span>E-mail: <a href={"mailto:dmitriy.burdenkov@agile-ce.cz"}>dmitriy.burdenkov@agile-ce.cz</a></span><br/>

                        </div>

                        <div className={"col-md-4"}>
                            <br/>

                            <h4>Veronika Frintová</h4>
                            <span>BIM projektant</span><br/>
                            <span>E-mail: <a href={"mailto:veronika.frintova@agile-ce.cz"}>veronika.frintova@agile-ce.cz</a></span><br/>

                        </div>

                    </div>
                    <br/><br/>
                    <h3>
                        Projekční Agilní tým<br/><br/>
                    </h3>

            <div className={"row"}>

                <div className={"col-md-4"}>
                    <br/>
                    <h4>Ing. arch. Hana Kaňkovská (AI)</h4>
                    <span>HIP, architekt, projektant pozemních staveb</span><br/>
                    <span>E-mail: <a href={"mailto:hana.kankovska@agile-ce.cz"}>hana.kankovska@agile-ce.cz</a></span><br/>

                </div>

                <div className={"col-md-4"}>
                    <br/>
                    <h4>MgA. Michal Doskočil</h4>
                    <span>Architekt</span><br/>
                    <span>E-mail: <a href={"mailto:michal.doskocil@agile-ce.cz"}>michal.doskocil@agile-ce.cz</a></span><br/>

                </div>
                <div className={"col-md-4"}>
                    <br/>
                    <h4>Dária Dupčáková</h4>
                    <span>Projektant</span><br/>
                    <span>E-mail: <a href={"mailto:daria.dupackova@agile-ce.cz"}>daria.dupcakova@agile-ce.cz</a></span><br/>

                </div>

            </div>






                </div>

            </div>







        </div>

</div>
    );
  }
}

export default withTranslation()(Office);
